.panel {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-subtle);
  background: var(--gradient-surface), var(--surface-solid);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.panel::before {
  content: '';
  position: absolute;
  inset: 0 0 auto 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-strong), transparent);
}

.interactive {
  cursor: pointer;
  transition:
    transform var(--duration-base) var(--ease-out),
    border-color var(--duration-base) var(--ease-out),
    box-shadow var(--duration-base) var(--ease-out);
}

.interactive:hover {
  transform: translateY(-2px);
  border-color: var(--border-brand);
  box-shadow: var(--shadow-lg);
}

.flush {
  padding: 0;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
}

.titleGroup {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.title {
  font-size: var(--text-lg);
  font-weight: 650;
}

.subtitle {
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
}

/**
 * Phone: give the content its width back.
 *
 * A panel is the frame around almost everything in this app, so its padding is
 * charged twice on every screen — 24px each side here, on top of the shell's
 * own, which is 80px of a 375px display spent before a single word is drawn.
 * That is what turns a two-column form into two unreadable columns and a table
 * cell into a wrap.
 *
 * The header is allowed to fold as well: an actions cluster that will not shrink
 * (`flex-shrink: 0`, correctly — those are buttons) next to a title that can is
 * exactly the pairing that pushes a row sideways.
 */
@media (max-width: 640px) {
  .panel {
    padding: var(--space-4);
    gap: var(--space-3);
  }

  .header {
    flex-wrap: wrap;
    gap: var(--space-2);
  }

  /**
   * Its own row, and allowed to shrink.
   *
   * `flex-wrap` alone does nothing here: `.actions` carries `flex-shrink: 0`, so
   * it sizes to its buttons and is never narrow enough to wrap inside. The wheel
   * editor's header holds three of them — 409px of button in a 309px panel — and
   * the panel clips rather than scrolls, so "Add slice" was simply not there.
   * Giving it the full row restores the constraint that makes wrapping happen.
   */
  .actions {
    flex: 1 1 100%;
    flex-wrap: wrap;
  }
}
